module.exports = __webpack_public_path__ + "static/media/hilltone1.83117497.png";